/**
 * Autocompleter.Request
 *
 * http://digitarald.de/project/autocompleter/
 *
 * @version      1.1.2
 *
 * @license      MIT-style license
 * @author      Harald Kirschner <mail [at] digitarald.de>
 * @copyright   Author
 */

Autocompleter.Request = new Class({
   Extends: Autocompleter,

   options: {
      /*
      indicator: null,
      indicatorClass: null,
      onRequest: function () {},
      onComplete: function () {},*/
      postData: {},
      ajaxOptions: {},
      postVar: 'value',
   },

   query: function() {
      var data = Object.clone(this.options.postData) || {};
      data[this.options.postVar] = this.queryValue;
      var indicator = $(this.options.indicator);
      if (indicator) {
         indicator.setStyle('display', '');
      }
      var cls = this.options.indicatorClass;
      if (cls) {
         this.element.addClass(cls);
      }
      this.fireEvent('onRequest', [this.element, this.request, data, this.queryValue]);
      data.csrf = CSRF.get();
      this.request.send({ data: data });
   },

   /**
    * queryResponse - abstract
    *
    * Inherited classes have to extend this function and use this.parent()
    */
   queryResponse: function() {
      var indicator = $(this.options.indicator);
      if (indicator) {
         indicator.setStyle('display', 'none');
      }
      var cls = this.options.indicatorClass;
      if (cls) {
         this.element.removeClass(cls);
      }
      return this.fireEvent('onComplete', [this.element, this.request]);
   },
});

Autocompleter.Request.JSON = new Class({
   Extends: Autocompleter.Request,

   initialize: function(el, url, options) {
      this.parent(el, options);
      this.request = new Request.JSON(
         Object.merge(
            {
               url: url,
               link: 'cancel',
            },
            this.options.ajaxOptions
         )
      ).addEvent('onComplete', this.queryResponse.bind(this));
   },

   queryResponse: function(response) {
      this.parent();
      this.update(response);
   },
});

Autocompleter.Request.HTML = new Class({
   Extends: Autocompleter.Request,

   initialize: function(el, url, options) {
      this.parent(el, options);
      this.request = new Request.HTML(
         Object.merge(
            {
               url: url,
               link: 'cancel',
               update: this.choices,
            },
            this.options.ajaxOptions
         )
      ).addEvent('onComplete', this.queryResponse.bind(this));
   },

   queryResponse: function(tree, elements) {
      this.parent();
      if (!elements || !elements.length) {
         this.hideChoices();
      } else {
         this.choices.getChildren(this.options.choicesMatch).each(
            this.options.injectChoice ||
               function(choice) {
                  var value = choice.innerHTML;
                  choice.inputValue = value;
                  this.addChoiceEvents(choice.set('html', this.markQueryValue(value)));
               },
            this
         );
         this.showChoices();
      }
   },
});

/**
 * We don't want to copy the existing autocompleter request business. We want
 * some items to come through as get data or as part of the endpoint.
 * @author Sterling!
 */
Autocompleter.Request.API_2_0 = new Class({
   Extends: Autocompleter,
   options: {
      indicator: null,
      indicatorClass: null,
      getData: {},
      ajaxOptions: {},
   },

   query: function() {
      this.toggleIndicator(true);

      var data = Object.clone(this.options.getData) || {};
      this.fireEvent('onRequest', [this.element, this.request, data, this.queryValue]);
      data.search = this.queryValue;
      this.request.send({ data: data });
   },

   initialize: function(el, endpoint, options) {
      this.parent(el, options);
      // Any options listed here have to be added to Request.API_2_0's
      // Request initialization options.
      this.request = new Request.API_2_0(
         endpoint,
         Object.merge(
            {
               link: 'cancel',
               method: 'get',
            },
            this.options.ajaxOptions
         )
      ).addEvent('onComplete', this.queryResponse.bind(this));
   },

   queryResponse: function(response) {
      this.toggleIndicator(false);

      this.fireEvent('onComplete', [this.element, this.request]);
      var decoded = JSON.decode(response);
      this.update(decoded.results || decoded);
   },

   toggleIndicator: function(show) {
      var indicator = $(this.options.indicator);
      if (indicator) {
         indicator.setStyle('display', show ? '' : 'none');
      }
      var cls = this.options.indicatorClass;
      if (cls) {
         this.element.toggleClass(cls, show);
      }
   },
});

/* compatibility */

Autocompleter.Ajax = {
   Base: Autocompleter.Request,
   Json: Autocompleter.Request.JSON,
   Xhtml: Autocompleter.Request.HTML,
};
